module.exports = __webpack_public_path__ + "static/media/blog_image_5.06a2c95a.webp";